"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetDefaultBroker = exports.GetBrandContext = exports.GetAvailableBrokers = void 0;
var _brandConfigs = require("@PetSureAustralia/petsure-brand-partner-configs/distConfigs/brandConfigs");
var GetAvailableBrokers = exports.GetAvailableBrokers = function GetAvailableBrokers(brandKey) {
  return Object.values(_brandConfigs.BrandConfigs).map(function (config) {
    var _config$theme;
    return config === null || config === void 0 || (_config$theme = config.theme) === null || _config$theme === void 0 ? void 0 : _config$theme.brand;
  }).filter(function (brand) {
    return (brand === null || brand === void 0 ? void 0 : brand.key) === brandKey;
  }).map(function (brand) {
    var _brand$broker;
    return brand === null || brand === void 0 || (_brand$broker = brand.broker) === null || _brand$broker === void 0 ? void 0 : _brand$broker.toLowerCase();
  });
};
var GetDefaultBroker = exports.GetDefaultBroker = function GetDefaultBroker(brandKey) {
  var _BrandConfigs$key;
  var key = brandKey === 'petsure' ? 'default' : brandKey;
  return (_BrandConfigs$key = _brandConfigs.BrandConfigs[key]) === null || _BrandConfigs$key === void 0 || (_BrandConfigs$key = _BrandConfigs$key.theme) === null || _BrandConfigs$key === void 0 || (_BrandConfigs$key = _BrandConfigs$key.brand) === null || _BrandConfigs$key === void 0 ? void 0 : _BrandConfigs$key.broker;
};
var GetBrandContext = exports.GetBrandContext = function GetBrandContext(brandKey, broker) {
  var compareText = function compareText(left, right) {
    return !!left && !!right && left.toLowerCase() === right.toLowerCase();
  };
  var contexts = Object.values(_brandConfigs.BrandConfigs).filter(function (config) {
    var _config$theme2;
    var brand = config === null || config === void 0 || (_config$theme2 = config.theme) === null || _config$theme2 === void 0 ? void 0 : _config$theme2.brand;
    return compareText(brand === null || brand === void 0 ? void 0 : brand.key, brandKey) && compareText(brand === null || brand === void 0 ? void 0 : brand.broker, broker);
  });
  if (contexts.length === 0) {
    return _brandConfigs.BrandConfigs[brandKey];
  }
  return contexts[0];
};